import { render, staticRenderFns } from "./add-report-item.vue?vue&type=template&id=0044d274&"
import script from "./add-report-item.vue?vue&type=script&lang=js&"
export * from "./add-report-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports